import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-personal-save',
  templateUrl: './personal-save.component.html',
  styleUrls: ['./personal-save.component.css']
})
export class PersonalSaveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
